<script>
  import currentUser from '../stores/auth';
  import {Link} from 'svelte-routing'
  import ProjectDesc from './ProjectDesc.svelte'
  import {createEventDispatcher} from 'svelte'
  import Confirm from './Confirm.svelte'
  import {getTimeZoneOffset} from '../functions-common/date'
  import db from '../db'

  export let project;
  export let editMode = false;

  const dispatch = createEventDispatcher();

  let showDeleteConfirm = false;

  let saveError = null;

  async function onSave() {
    try {
      if (!project?.name?.length) throw 'Enter project name';
      if (project?.startEdit?.length !== 16) throw 'Select start date';
      if (project?.endEdit?.length !== 16) throw 'Select end date';
      if (!Number.isFinite(project?.max_attempts) || project.max_attempts <= 0) throw 'The number of attempts should be >= 1';
      if (!Number.isFinite(project?.max_time_for_attempt) || project.max_time_for_attempt <= 0) throw 'The max time of attempt should be >= 1';
      if (!Number.isFinite(project?.token_validity) || project.token_validity <= 0) throw 'Token validity should be >= 1';

      const {project_id, startEdit, endEdit, ...rest} = project;

      const newData = {
        ...(project_id ? {project_id} : null),
        ...rest,
        start: startEdit + ':00' + getTimeZoneOffset(),
        end: endEdit + ':00' + getTimeZoneOffset(),
      }

      const {error} = await db
        .from('projects')
        .upsert([newData]);

      if (error) throw 'DB Error';

      dispatch('cancel', project);
    } catch (err) {
      saveError = err
    }
  }

  async function onDeleteConfirmed() {
    if (!project?.project_id) return;

    const {error} = await db
      .from('projects')
      .delete()
      .eq('project_id', project.project_id);

    if (error) throw 'DB Error';

    showDeleteConfirm = false;
  }
</script>

{#if project}
  {#if !editMode}
    <h3>{project.name}</h3>
  {:else}
    <label>Name</label>
    <input type="text" class="nes-input" bind:value={project.name} placeholder="Project name..."/>
  {/if}

  <ProjectDesc {project} {editMode}/>

  <div class="action">
    {#if !editMode}
      {#if $currentUser}
        <button type="button" class="nes-btn is-warning" on:click={() => dispatch('edit', project)}>Edit project
        </button>

        <Link to="/admin/project/{project.project_id}/edit">
          <button type="button" class="nes-btn is-success">Edit maps</button>
        </Link>

        <button type="button" class="nes-btn is-error" on:click={() => showDeleteConfirm = true}>Delete project</button>
      {/if}

      <Link to="/project/{project.project_id}">
        <button class="nes-btn is-primary">Show</button>
      </Link>

      <Confirm title="Warning" desc="Are you sure you want to delete project?" bind:show={showDeleteConfirm}
               on:confirm={onDeleteConfirmed} on:cancel={() => showDeleteConfirm = false}
      />
    {:else}
      {#if saveError}
        <div class="nes-text is-error">{saveError}</div>
      {/if}
      <button class="nes-btn is-primary" on:click={onSave}>Save</button>
      <button class="nes-btn" on:click={() => dispatch('cancel', project)}>Cancel</button>
    {/if}
  </div>
{/if}

<style>
    label {
        color: #888;
        margin-bottom: .25rem;
    }

    input {
        margin-left: -4px;
        margin-bottom: 1rem;
    }

    .nes-text.is-error {
        margin-bottom: 1rem;
    }
</style>